export default __webpack_public_path__ + "static/media/news.78d3e3ad.mp4";